module.exports = __webpack_public_path__ + "static/media/home_bg.4d0f3265.webp";